import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { activeOrganization$ } from "~/stores/organizations";

/**
 * Parent route for the post-catalog key-tables step. Owns the shared
 * `beforeLoad` gate so both the param child (`$datasourceId`) and the resume
 * fallback (`index`) inherit it.
 *
 * Accepts `"catalog"` and `"keyTables"` so navigations from `/onboard/catalog`
 * after Continue aren't bounced during the brief window before
 * `setOrgOnboardingStep("keyTables")` resolves.
 */
export const Route = createFileRoute("/onboard/key-tables")({
  beforeLoad: ({ context }) => {
    if (context.user?.onboarding !== "done") {
      throw redirect({ to: "/onboard", replace: true });
    }
    const org = activeOrganization$.get();
    if (!org?.id) {
      throw redirect({ to: "/onboard", replace: true });
    }
    if (org.onboarding !== "catalog" && org.onboarding !== "keyTables") {
      throw redirect({ to: "/onboard", replace: true });
    }
  },
  component: () => <Outlet />,
});
